import {useContext} from "react";
import Context from "./context";

export default function usePaginationContext() {
  return useContext(Context);
}
